import React from 'react'
import { ComponentConfig, Slot } from '@puckeditor/core'
import {
  getPuckFileUrl,
  UploadedFile,
} from 'breaktime-theme/src/puck/fields/FileUploadField'
import { ThemeCustomFields } from 'breaktime-theme/src/puck/theme-config'
import {
  TypographyProps,
  fontFamilyField,
  fontFamilyFallbackField,
  textTransformField,
  fontWeightOptions,
  applyTypography,
  FontWeight,
} from 'breaktime-theme/src/puck/fields/StyleFields'

export type PollProductProps = {
  id?: string
  label: string
  image: UploadedFile | string
  dropdownButton: Slot
  fontFamily?: TypographyProps['fontFamily']
  fontFamilyFallback?: TypographyProps['fontFamilyFallback']
  textTransform?: TypographyProps['textTransform']
  fontSize?: string
  fontWeight?: FontWeight
}

export const POLL_PRODUCT_DEFAULT_PROPS: PollProductProps = {
  label: 'Product name',
  image: '',
  dropdownButton: [],
}

export const PuckPollProduct: ComponentConfig<{
  props: PollProductProps
  fields: ThemeCustomFields
}> = {
  label: 'Poll Product',
  defaultProps: POLL_PRODUCT_DEFAULT_PROPS,
  fields: {
    label: {
      type: 'text',
      label: 'Product Label',
    },
    image: {
      type: 'fileUpload',
      label: 'Product Image',
    },
    dropdownButton: {
      type: 'slot' as const,
      allow: ['PollDropdownButton'],
      disallow: [
        'PollContainer',
        'PollQuestion',
        'PollAnswer',
        'PollProduct',
        'PollProductPanel',
        'PollNextQuestionButton',
      ],
    },
    fontFamily: fontFamilyField,
    fontFamilyFallback: fontFamilyFallbackField,
    textTransform: textTransformField,
    fontSize: { type: 'text' as const, label: 'Font Size', placeholder: '14px' },
    fontWeight: { type: 'select' as const, label: 'Font Weight', options: fontWeightOptions },
  },
  render: ({ label, image, dropdownButton: DropdownButtonSlot, fontFamily, fontFamilyFallback, textTransform, fontSize, fontWeight }) => {
    const imageUrl = typeof image === 'string' ? image : getPuckFileUrl(image)
    return (
      <div
        className="embla__slide poll-product-slide"
        style={{ minWidth: 120, flex: '0 0 auto' }}
      >
        {imageUrl && (
          <img src={imageUrl} alt={label || ''} style={{ width: '100%' }} />
        )}
        {label && (
          <span
            style={{
              ...applyTypography({ fontFamily, fontFamilyFallback, textTransform }),
              ...(fontSize ? { fontSize } : {}),
              ...(fontWeight ? { fontWeight: Number(fontWeight) || undefined } : {}),
            }}
          >
            {label}
          </span>
        )}
        <DropdownButtonSlot
          allow={['PollDropdownButton']}
          disallow={[
            'PollContainer',
            'PollQuestion',
            'PollAnswer',
            'PollProduct',
            'PollProductPanel',
            'PollNextQuestionButton',
          ]}
          minEmptyHeight={28}
        />
      </div>
    )
  },
}
